export default class ErrorCode {
  public static readonly Success = 1;

  public static readonly LoginAccountOrPasswordError = 13;
  
  public static readonly InitLogin = 27;

  public static readonly ParamsterInvalid = 5;
}
